import React, { useState, useEffect } from 'react';
import HelpTogal from '../TogelButton/HelpTogal';
import SubCategoryServices from '../../services/SubCategoryServices';

function UpdateSubCategory({ subcategory, closeModal, onSuccess }) {

  console.log("dddddddddddd", subcategory);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await SubCategoryServices.getCategoryActive();
        if (res.status) {
          setCategories(res.data);
        } else {
          alert('Failed to fetch categories');
        }
      } catch (error) {
        console.error('Error fetching categories', error);
        alert('Failed to fetch categories');
      }
    };
    fetchCategories();
  }, []);

  const [formValues, setFormValues] = useState({
    title: '',
    sequence: '',
    image: '',
  });
  const [previewImage, setPreviewImage] = useState('img/placeholder-img.png');

  useEffect(() => {
    if (subcategory) {
      setFormValues({
        title: subcategory?.title || '',
        sequence: subcategory?.sequence || '',
        image: subcategory?.image || '',
        category: subcategory?.category?._id


      });
      if (subcategory.image) {
        setPreviewImage(process.env.REACT_APP_URL + subcategory.image);
      }
    }
  }, [subcategory]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
      setFormValues({
        ...formValues,
        image: file,
      });
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const formData = new FormData();
      for (const key in formValues) {
        if (key !== 'image' || formValues[key] instanceof File) {
          formData.append(key, formValues[key]);
        }
      }

      await SubCategoryServices.updateCategory(subcategory.id, formData);
      alert('Category updated successfully');
      onSuccess();
      closeModal();
    } catch (error) {
      console.error('Failed to update category', error);
      alert('Failed to update category');
    }
  };

  return (
    <div className="modal fade edit-box show d-block" id="editModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title"> Edit Category</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={closeModal} aria-label="Close" />
          </div>
          <div className="modal-body">
            <div className="container-box px-5">
              <div className="container-box-inner table-reponsive-tabe">
                <div className="page-details">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className='row'>
                        <div className="col-lg-12 col-md-12">
                          <div className="input-field">
                            <label>Category*</label>
                            <select
                              name="category"
                              className="form-control"
                              value={formValues.category }
                              onChange={handleInputChange}
                            >
                              <option value="">Select a category</option>
                              {categories.map((category) => (
                                <option key={category._id} value={category._id}>
                                  {category.title}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-13 col-sm-12">
                        <div className="input-field">
                          <label>Sub Category</label>
                          <input type="text" name="title" className="form-control" value={formValues.title} onChange={handleInputChange} placeholder="New category" required />
                        </div>
                      </div>

                      <div className="col-lg-6 col-md-6">
                        <div className="input-field">
                          <label>Select Sequence</label>
                          <select className="form-control" value={formValues.sequence} onChange={handleInputChange} name="sequence">
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-sm-9">
                        <div className="input-field">
                          <label>Upload<span className="red">*</span></label>
                          <input type="file" name="image" className="form-control" onChange={handleFileChange} />
                          <p><span>Drop an image or Paste URL (up to resolution 1,500 x 1,500 px),</span> Supported formats: png, jpeg, jpg, webp</p>
                          <div className="file-preview text-center">
                            <img id="uploadFile" src={previewImage} alt="your image" />
                          </div>
                        </div>
                      </div>

                    </div>
                    <button className="submit-green-btn">Submit</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpdateSubCategory;
